import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Popup from "components/popup/Popup";
import { ButtonNew as Button } from "components/buttonNew";

/** Sizes defined by e-Range. Today and future buckets use different codes for the same labels. */
const TODAY_BUCKET_SIZES = [
  { size: 1, label: "Small" },
  { size: 2, label: "Medium" },
  { size: 3, label: "Large" },
  { size: 4, label: "X-Large" },
] as const;

const FUTURE_BUCKET_SIZES = [
  { size: 11, label: "Small" },
  { size: 12, label: "Medium" },
  { size: 13, label: "Large" },
  { size: 14, label: "X-Large" },
] as const;

export function isERangeProduct(type?: any) {
  return type === "e-Range";
}

export function eRangeBucketSizesForProduct(productTitle?: string | null) {
  return /future/i.test(productTitle ?? "") ? FUTURE_BUCKET_SIZES : TODAY_BUCKET_SIZES;
}

export function ERangeBucketSizeModal({
  open,
  productTitle,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  productTitle?: string | null;
  onCancel: () => void;
  onConfirm: (bucketSize: number) => void;
}) {
  const { t } = useTranslation();
  const options = eRangeBucketSizesForProduct(productTitle);
  const [selected, setSelected] = useState<number | null>(null);

  useEffect(() => {
    if (open) {
      setSelected(null);
    }
  }, [open]);

  return (
    <Popup
      open={open}
      type="warning"
      title={t("e-Range bucket size")}
      description={t("Choose the bucket size for this variant. e-Range uses it when generating pins.")}
      okText={t("Continue")}
      okDisabled={selected == null}
      onCancel={onCancel}
      onOk={() => {
        if (selected != null) {
          onConfirm(selected);
        }
      }}
    >
      <div className="flex flex-col gap-2">
        {options.map(option => (
          <Button
            key={option.size}
            type={selected === option.size ? "primary" : "secondary"}
            onClick={() => setSelected(option.size)}
            className="ml-0"
            block
          >
            {t(option.label)}
          </Button>
        ))}
      </div>
    </Popup>
  );
}
